import { useState } from "react";
import {
  Container,
  Button,
  Stack,
  Box,
  Group,
  rem,
  Grid,
  Textarea,
  Text,
} from "@mantine/core";
import { useStore } from "../store";
import { Redirect, useLocation } from "wouter";
import {
  IconArrowRight,
  IconDownload,
  IconPlaylistAdd,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import { deleteImages } from "../api";
import ExtendVideoModal from "../SuperGallery/ExtendVideoModal";

function VideoPage() {
  const imageData = useStore((state) => state.imageData);
  const setImageData = useStore((state) => state.setImageData);
  const setGeneratorConfig = useStore((state) => state.setGeneratorConfig);
  const [, setLocation] = useLocation();
  const [extendOpen, setExtendOpen] = useState(false);

  if (!imageData) return <Redirect to="/generate" />;
  if (!imageData.videoUrl) return <Redirect to="/editor" />;

  return (
    <Container fluid m={0} p={0}>
      <Grid>
        <Grid.Col span={3}>
          <Stack>
            <Box>
              <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                Created
              </Text>
              <Text>{imageData.created}</Text>
            </Box>

            {imageData.pluginTitle && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Plugin
                </Text>
                <Text>{imageData.pluginTitle}</Text>
              </Box>
            )}

            {imageData.pluginTitle && imageData.pluginFilterLabel && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Filter
                </Text>
                <Text>{imageData.pluginFilterLabel}</Text>
              </Box>
            )}

            {imageData.pluginPresetLabel && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Preset
                </Text>
                <Text>{imageData.pluginPresetLabel}</Text>
              </Box>
            )}

            {(imageData.pluginInputs ?? []).map((row) => (
              <Box key={row.label || row.value}>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  {row.label}
                </Text>
                <Text>{row.value}</Text>
              </Box>
            ))}

            {imageData.pluginPrompt && (
              <Box>
                <Text fz="xs" mb="xs" fw={600} tt="uppercase" c="dimmed">
                  Prompt
                </Text>
                <Textarea
                  value={imageData.pluginPrompt}
                  minRows={2}
                  maxRows={12}
                  autosize
                  disabled
                />
              </Box>
            )}

            {imageData.pluginSeed != null && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Seed
                </Text>
                <Text>{imageData.pluginSeed}</Text>
              </Box>
            )}

            {imageData.generateConfig?.config && (
              <Box>
                <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
                  Styles
                </Text>
                <Text>{imageData.generateConfig.config.Action}</Text>
              </Box>
            )}

            {!imageData.pluginTitle && imageData.generateConfig?.prompt && (
              <Box>
                <Text fz="xs" mb="xs" fw={600} tt="uppercase" c="dimmed">
                  Prompt
                </Text>
                <Textarea
                  value={imageData.generateConfig.prompt}
                  minRows={3}
                  maxRows={15}
                  autosize
                  disabled
                />
              </Box>
            )}

            {imageData.generateConfig && (
              <Button
                variant="gradient"
                onClick={() => {
                  setGeneratorConfig(imageData.generateConfig);
                  setLocation("/generate");
                }}
                rightSection={<IconArrowRight />}
              >
                Generate similar
              </Button>
            )}
          </Stack>
        </Grid.Col>
        <Grid.Col span={9}>
          <video
            width="100%"
            height="auto"
            poster={imageData.videoPosterUrl || undefined}
            style={{
              minHeight:
                "calc(100dvh - var(--app-shell-header-height, 0px) - var(--app-shell-header-offset, 0px) - var(--app-shell-footer-height, 0px) - 60px)",
              maxHeight: "80dvh",
            }}
            controls
          >
            <source src={imageData.videoUrl} type="video/mp4" />
          </video>
          <div style={{ flex: 1 }}></div>
          <div>
            <Group justify="space-evenly" wrap p="sm">
              <Button.Group>
                <Button
                  variant="light"
                  size="xs"
                  color="grape"
                  leftSection={
                    <IconPlaylistAdd style={{ width: rem(18) }} stroke={1.5} />
                  }
                  onClick={() => setExtendOpen(true)}
                >
                  Extend
                </Button>
                <Button
                  variant="light"
                  size="xs"
                  color="red"
                  loaderProps={{ type: "dots" }}
                  leftSection={
                    <IconTrash style={{ width: rem(18) }} stroke={1.5} />
                  }
                  onClick={() =>
                    deleteImages([imageData.logicalImageId]).then(() => {
                      setImageData(null);
                      setLocation("/gallery");
                    })
                  }
                >
                  Delete
                </Button>
                <Button
                  component="a"
                  variant="default"
                  size="xs"
                  target="_blank"
                  href={imageData.videoUrl}
                  aria-label="Download"
                  leftSection={
                    <IconDownload style={{ width: rem(18) }} stroke={1.5} />
                  }
                >
                  Download
                </Button>
                <Button
                  leftSection={
                    <IconX style={{ width: rem(18) }} stroke={1.5} />
                  }
                  variant="default"
                  size="xs"
                  aria-label="Close"
                  onClick={() => {
                    setImageData(null);
                    setLocation("/gallery");
                  }}
                >
                  Close
                </Button>
              </Button.Group>
            </Group>
          </div>
        </Grid.Col>
      </Grid>
      <ExtendVideoModal
        opened={extendOpen}
        onClose={() => setExtendOpen(false)}
        source={imageData}
      />
    </Container>
  );
}

export default VideoPage;
